"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLinesStartEndDate = void 0;
const dayjs = require("dayjs");
const getOrderLinesStartEndDate = (order_lines) => {
    const dates = [];
    const hotel_lines = order_lines.filter((orderLine) => {
        return orderLine.type === "HOTEL";
    });
    const other_lines = order_lines.filter((orderLine) => {
        return orderLine.type !== "HOTEL";
    });
    hotel_lines.forEach((hotel_line) => {
        const config = hotel_line?.latest_version.config;
        dates.push({
            start: dayjs(config.where_when_who?.check_in_date).format("YYYY-MM-DD"),
            end: dayjs(config.where_when_who?.check_in_date)
                .add(config.where_when_who?.number_of_nights, "day")
                .format("YYYY-MM-DD"),
        });
    });
    other_lines.forEach((line) => {
        dates.push({
            start: dayjs(line?.latest_version.start_date).format("YYYY-MM-DD"),
            end: dayjs(line?.latest_version.start_date).format("YYYY-MM-DD"),
        });
    });
    // from all the dates get the earliest date and the latest date
    return findEarliestAndLatest(dates);
};
exports.getOrderLinesStartEndDate = getOrderLinesStartEndDate;
function findEarliestAndLatest(dates) {
    if (dates.length === 0) {
        return {
            start: null,
            end: null,
        };
    }
    let earliestStart = dayjs(dates[0].start);
    let latestEnd = dayjs(dates[0].end);
    for (const range of dates) {
        const startDate = dayjs(range.start);
        const endDate = dayjs(range.end);
        if (startDate.isBefore(earliestStart)) {
            earliestStart = startDate;
        }
        if (endDate.isAfter(latestEnd)) {
            latestEnd = endDate;
        }
    }
    return {
        start: earliestStart.format("YYYY-MM-DD"),
        end: latestEnd.format("YYYY-MM-DD"),
    };
}
